import { InputSwitch } from "primereact/inputswitch";
import { Controller, useFormContext } from "react-hook-form";

export function BilateralToggle() {
  const { control, setValue } = useFormContext();

  return (
    <div className="field col-12 md:col-6 p-3">
      <label htmlFor="isBilateral" className="font-medium mb-2 block">
        Bilateral
      </label>
      <Controller
        name="isBilateral"
        control={control}
        render={({ field }) => (
          <div className="flex align-items-center gap-2">
            <InputSwitch
              checked={!!field.value}
              onChange={(e) => {
                field.onChange(e.value);
                if (e.value) {
                  setValue("isPerDiem", false, { shouldDirty: true });
                }
              }}
            />
            <span className="text-sm text-600">
              Pay 100% of the first + 50% of a second duplicate CPT (150% total)
            </span>
          </div>
        )}
      />
    </div>
  );
}
